import axiosInstance from "../lib/axios";
import type { DosPayload } from "../type/dos";

interface GetDosRequest {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

// =========================
// DOS Status List
// =========================

export const getDosStatus = async () => {
  const { data } = await axiosInstance.get("/Dos/dos-status");

  return data;
};

// =========================
// DOS List
// =========================

export const getDosList = async ({
  page = 1,
  limit = 10,
  search,
  status,
}: GetDosRequest) => {
  const body = {
    page,
    limit,
    // search/status hanya dikirim kalau diisi (status = code, mis. DRAFT).
    ...(search ? { search } : {}),
    ...(status ? { status } : {}),
  };

  const { data } = await axiosInstance.post("/Dos/List", body);

  return data;
};

// =========================
// Create / Detail / Edit / Delete
// =========================

export const createDos = (data: DosPayload) => {
  return axiosInstance.post("/Dos/Create", data);
};

export const getDosById = (id: number) => {
  return axiosInstance.get(`/Dos/${id}`);
};

export const editDos = (id: number, data: DosPayload) => {
  return axiosInstance.put(`/Dos/${id}`, data);
};

export const deleteDos = (id: number) => {
  return axiosInstance.delete(`/Dos/${id}`);
};

// =========================
// Perpindahan status
// =========================

export const submitDos = (id: number) => {
  return axiosInstance.post(`/Dos/${id}/submit`);
};

export const approveDos = (id: number) => {
  return axiosInstance.post(`/Dos/${id}/approve`);
};

export const rejectDos = (id: number, rejectionReason: string) => {
  return axiosInstance.post(`/Dos/${id}/reject`, {
    rejection_reason: rejectionReason,
  });
};

export const convertDos = (id: number) => {
  return axiosInstance.post(`/Dos/${id}/convert`);
};

// =========================
// DOS PDF (hanya APPROVED/CONVERTED)
// =========================

export const dosPdf = (id: number) => {
  return axiosInstance.post(`/Dos/${id}/pdf`, null, {
    responseType: "blob", // WAJIB, kalau tidak PDF-nya bakal corrupt
  });
};
